export default __webpack_public_path__ + "static/media/img_chart_grade_D-.6a6bbb7cb7e151570e5a9ebe5c0bcc98.svg";